/* 🤖 this file was generated by script */
export const wiconChevronDown = {
  name: 'chevron_down',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 9l6 6 6-6"/></svg>`,
};
